import type { FaireProductEntity } from "../../entity_types/product";

export const p_dp7ftbbh7d: FaireProductEntity = {
  token: "p_dp7ftbbh7d",
  type: "product",
  name: "Savoy Vase L",
  brandToken: "b_6jjy4txuzi",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/a0e1108287db8358e145101bec518c736a6e5746f007c34cc31abdddaac4d461.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2e1e8ccf3dd6f6740580b9c22a2083ee80ee88b54da8f6127b81546c66fe288a.jpeg",
    "https://cdn.faire.com/fastly/4cac6197aae184bfe80a3d7e34229ece9a1fad409fdb9210c8f9b27c1bb25967.jpeg",
    "https://cdn.faire.com/fastly/290c6b0b68d14df0a21273212de3a6ea28219a95d8e1d8dadd1f812a8e212d7c.jpeg",
  ],
  priceDollars: 58.3,
  description:
    "Savoy Vase L, A Decorative Vase Inspired by Ancient Forms for Modern Accent Decor\r\n\r\nWith its elegant silhouette and urn-like shape, the Savoy Vase brings sculptural presence to any space. Made of cast aluminum with a creamy, high-gloss finish, this decorative vase mimics the look of aged ceramic, with a dark underlayer that subtly peeks through to add depth and character.\r\n\r\nIts curving handles and classic form nod to ancient vessels, while the sleek sheen offers a modern update that fits beautifully into both rustic and contemporary interiors. Use it to anchor a console, accent a dining table, or display as a standalone statement.\r\n\r\nMaterials & Composition: 100% Aluminum\r\n\r\nCare Instructions: Wipe Clean with Dry Cloth\r\n\r\nFeatures & Benefits:\r\nMade from durable cast aluminum\r\nCreamy gloss finish with tonal depth\r\nSculptural silhouette with ancient urn inspiration\r\nVersatile accent decor piece for styling shelves, tables, or mantels",
  tags: [],
  msrpDollars: 116.6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:33.359Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
